<template>
  <div class="information">
    <el-card class="box-card clearfix">

      <el-form ref="form" :model="form" label-width="0px" :rules="rules">
        <div class="vertical fl">
          <i class="el-icon-edit pvt-color" style="font-size: 24px;"></i>
          <span>写文章</span>
        </div>
        <el-form-item label="" class="clearfix" prop="title">
          <p class="fl">标题</p>
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="" prop="content" class="clearfix">
          <p class="fl">内容</p>
          <div class="clearfix">
            <Vditor v-model="form.content" editorId="vditor" />
          </div>
        </el-form-item>
        <el-form-item label="" prop="subCategoryId">
          <div class="clearfix">
            <p class="fl">标签</p>
          </div>

          <div class="vertical fl">
            <el-tag v-if="activeSubCategory.subCategoryName != null" type="warning">
              {{activeSubCategory.subCategoryName}}
            </el-tag>
            <i class="el-icon-plus pvt-color" style="font-size: 22px;" @click="openDialog"></i>
            <span>至少添加一个标签</span>
          </div>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="" class="fl">
         <!-- <el-checkbox v-model="anonymousFlag">匿名</el-checkbox>-->
          <el-button @click="submitTopic('save')" class="main-bg-color" size="tiny" >
            保存
          </el-button>
          <el-button @click="submitTopic('submit')" class="main-bg-color" size="tiny" >
            发布文章
          </el-button>
        </el-form-item>
      </el-form>

    </el-card>
    <el-dialog title="选择标签" :visible.sync="dialogVisible" width="50%">
      <el-radio-group v-model="form.subCategoryId">
        <el-radio v-for="o in subCategoryList" @change="setActiveSubCategory(o)" :label="o.subCategoryId"
                  :key="o.subCategoryId">{{o.subCategoryName}}
        </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
  import Vditor from '@/components/editor/vditor'
  import {Message} from "element-ui";

  export default {
    components: {Vditor},
    data() {
      return {
        form: {
          title: '',
          content: '', //富文本的内容
          categoryId: this.$route.query.type, // 1官方资讯，2问答，3专栏博客，4社区活动
          subCategoryId: ''
        },
        activeSubCategory: {},
        anonymousFlag: false,
        dialogVisible: false,
        subCategoryList: [],
        rules: {
          title: [{required: true, message: '请输入标题', trigger: 'blur'}],
          content: [{required: true, message: '请输入内容', trigger: 'blur'}],
          subCategoryId: [{required: true, message: '请选择标签', trigger: 'change'}],
        },
        baseUrl: window.baseUrl, //默认为'' 空字符串
        timeOutId: 0,//用户不主动保存，每三分钟自动保存一次
      }
    },
    computed: {
      realHeight() {
        return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 200
      }
    },
    methods: {
      async imgUpload(blobInfo, success, failure) {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        try {
          this.postMultipartRequest('/util/upload/picFile', formData).then(resp => {
            if (resp && resp.status == 200) {
              var url = resp.data.result.url;
              success(url);

            }
          })

        } catch (e) {
          console.log(e);
          failure('上传失败:' + e);
        }
      },
      submitTopic: function (submitType) {
        var _this = this;
        var params = {};
        params.title = _this.form.title;
        params.content = _this.form.content;
        params.categoryId = _this.form.categoryId
        params.subCategoryId = _this.form.subCategoryId
        params.anonymousFlag = _this.anonymousFlag
        console.log(params)
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/tccTopic/addTopic?anonymousFlag=' + _this.anonymousFlag, JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  Message.success(data.message);
                  _this.form = {};
                  console.log(submitType == 'save')
                  if(submitType == 'save'){
                    console.log(data)
                    this.$router.push({
                      path: '/information/edit',
                      query:{type:this.$route.query.type,id:data.result.id}
                    })
                  }else {
                    this.$router.push({
                      path: '/information',
                      query:{type:this.$route.query.type}
                    })
                  }

                } else {
                  Message.error(data.message);
                  _this.change();
                }

              }
            });
          }
        })
      },
      getSubCategories: function () {
        this.getRequest('/tccTopic/getSubCategoryList', {'categoryId': this.categoryId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.subCategoryList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      openDialog: function () {
        this.dialogVisible = true;
      },
      setActiveSubCategory: function (o) {
        this.activeSubCategory = o;
        console.log(this.activeSubCategory)
      },
      autoSave(){
        this.submitTopic('save')
        this.timeOutId = setTimeout(this.autoSave,3 * 60 * 1000);
      },
      handleInput(newContent) {
        this.form.content = newContent;
        console.log(this.form.content)
      },
    },
    mounted: function () {
      this.getSubCategories();
    },
    created() {
      this.timeOutId = setTimeout(this.autoSave,3 * 60 * 1000);
    },
    destroyed(){
      clearTimeout(this.timeOutId)
    },
  }
</script>
<style scoped>
.information {
    max-width: 100%;
    margin: 20px  auto;
}
</style>
